import { render, staticRenderFns } from "./storesOrders.vue?vue&type=template&id=adc75b76"
import script from "./storesOrders.vue?vue&type=script&lang=js"
export * from "./storesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports